<template>
    <div>
        <el-tooltip class="item" placement="left" effect="light" :disabled="noChoosed" popper-class="tooltipEquipment">
            <div slot="content" style="line-height:14px">
                <div>{{$t('WorkShopDashBoard.tooltipTitle1')}}: {{selectmachineInfo.equipmentName}}</div>
                <div>{{$t('WorkShopDashBoard.tooltipTitle2')}}: {{selectmachineInfo.nameZh}}</div>
                <div>{{$t('WorkShopDashBoard.tooltipTitle3')}}: <span v-if="selectmachineInfo.hasOwnProperty('contractNo') && selectmachineInfo.contractNo != '' && selectmachineInfo.contractNo !== null">{{selectmachineInfo.contractNo}}</span><span v-else>-</span></div>
                <div>{{$t('WorkShopDashBoard.tooltipTitle4')}}:
                    <span v-if="selectmachineInfo.machineLifeCycle === 1">{{$t('WorkShopDashBoard.machineLifeList1')}}</span>
                    <span v-else-if="selectmachineInfo.machineLifeCycle === 2">{{$t('WorkShopDashBoard.machineLifeList2')}}</span>
                    <span v-else-if="selectmachineInfo.machineLifeCycle === 3">{{$t('WorkShopDashBoard.machineLifeList3')}}</span>
                    <span v-else-if="selectmachineInfo.machineLifeCycle === 4">{{$t('WorkShopDashBoard.machineLifeList4')}}</span>
                    <span v-else-if="selectmachineInfo.machineLifeCycle === 5">{{$t('WorkShopDashBoard.machineLifeList5')}}</span>
                    <span v-else-if="selectmachineInfo.machineLifeCycle === 6">{{$t('WorkShopDashBoard.machineLifeList6')}}</span>
                    <span v-else-if="selectmachineInfo.machineLifeCycle === 7">{{$t('WorkShopDashBoard.machineLifeList7')}}</span>
                </div>
            </div>
            <el-popover
                v-model="visible"
                placement="bottom-end"
                width="500"
                popper-class="chooseEquipment"
                trigger="click"
                ref="popover">
                <div class="noMachine" v-if="activemachineList.length==0">{{$t('Dailyequipment.noEquipmentData')}}</div>
                <ul class="machineList" v-else>
                    <li  @click="selectmachineId(all)" :class="{'active':selectmachine===''}" v-if="showall">{{$t('PartsFaultAlarm.all')}}</li>
                    <li v-for="item in activemachineList" :class="{'active':item.value===selectmachine}" :key="item.value" :info='item.value' @click="selectmachineId(item)" >{{item.label}}</li>
                </ul>
                <el-input class="rightEquipment" suffix-icon="el-icon-arrow-down" slot="reference" v-model="machineName" :readonly="true" :placeholder="$t('StepCycleTime.placehoder1')" @click="visible = true"></el-input>
            </el-popover>
        </el-tooltip>
    </div>
</template>

<script>
export default {
    props:{
        machine:Number,
        initmachine:'',
        show:Boolean,
        hideEquipment:Array
    },
    watch:{
        initmachine(){
            this.selectmachine=this.machine
            this.machineName=this.initmachine
        },
        machine(){
            this.selectmachine = this.machine
            if(this.machineList!= null && this.machineList.length != 0){
                for(let i=0;i<this.machineList.length;i++){
                    if(this.machineList[i].value==this.machine){
                        this.machineName=this.machineList[i].label
                    }
                }
            }
            // this.getmachineList()
        },
        activemachineList(){
            if(this.activemachineList== undefined || this.activemachineList.length <= 0 ){
                this.$message(this.$t('Dailyequipment.noEquipmentData'));
            }
        }
    },
    computed: {
        activemachineList(){
            return this.machineList.filter((item)=>{
                if(this.hideEquipment){
                    return (this.hideEquipment.indexOf(item.value)==-1)
                }else{
                    return (this.machineList)
                }
            })
        }
    },
    data(){
        return{
            visible: false,
            //设备列表
            machineList:[],
            machineName:'',
            selectmachineInfo:'',
            selectmachine:'',
            factoryId:'',
            all:{label:"全部",value:''},
            showall:this.show,
            // 设备生命周期情况
            machineLifeList: ['Manufacturing', 'Ex-factoryTesting', 'ErectionTesting', 'Using', 'Maintenance', 'TechnicalReconstruction','Write-off'],
            machineLifeListCh: ['制造中', '出厂前调试', '安装调试','使用中', '维护维修中', '技术改造中', '已报废'],
            //未选择机器
            noChoosed:true
        }
    },
    created(){

        if (this.$store.state.reloadState === false) {
            this.$store.state.reloadState = true
            this.reload()
        }else{
            this.getmachineList()
        }
        
    },
    methods:{
        reload () {
            this.$store.state.isRouterAlive = false
            this.$nextTick(function () {
                this.$store.state.isRouterAlive = true
            })
        },
        // 获取机械列表
        getmachineList(){
            let _this = this
            this.axios({
                method: 'get',
                url: '/url/selectChooseManice',
                params:{
                    language: _this.$store.state.lang
                }
            }).then(function(res){
                if (res.data.success === 'true'){
                    if(res.data.options !==undefined && res.data.options.length > 0 ){
                        if(localStorage.getItem('isMarketAccount') === '1') {
                            _this.$store.commit('marketAccount',res.data.options)
                        }
                        if(_this.machine==0){
                            if(_this.$store.state.lang===1){
                                _this.machineName='全部'
                            }else{
                                _this.machineName='All'
                            }
                            _this.selectmachine=''
                        }
                        else{
                            if(_this.machine==undefined)_this.noChoosed=true
                            else _this.noChoosed=false
                            res.data.options[0].children.forEach(element => {
                                if(element.value === _this.machine){
                                    _this.machineName = element.label
                                    _this.selectmachine = element.value
                                    _this.selectmachineInfo = element.machine
                                }
                            });
                        }
                        _this.machineList = res.data.options[0].children
                    }else{
                        _this.$message(_this.$t('Dailyequipment.noEquipmentData'));
                        _this.$store.state.machineList=res.data.options
                        _this.$store.commit('loginOut')
                        _this.$router.replace({
                            path: '/login'
                        })
                    } 
                }else{
                    _this.$message.error(res.data.msg);
                }
            })  
        },
        selectmachineId(event){
            if(event.value===''){
                this.noChoosed=true
                if(this.$store.state.lang===1){
                    this.machineName='全部'
                }else{
                    this.machineName='All'
                }
                this.selectmachine=event.value
            }else{
                this.noChoosed=false
                this.machineName= event.label
                this.selectmachine=event.value
                this.selectmachineInfo=event.machine
                // this.getmachineList()
            }
            this.$refs.popover.doClose()
            this.$emit('change',event.value)
        }
    }
}
</script>

<style scoped>
.machineList{
   display: flex;
   flex-wrap: wrap;
}
.machineList li{
  width: 150px;
  margin: 0 5px;
  text-align: center;
  height: 24px;
  line-height: 24px;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.25);
  border:1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
  font-size: 13px;
  cursor: pointer;
}
.active{
  color:#fff;
  background: #66b1ff;
}
.noMachine{
    text-align: center;
    line-height: 40px;
    color: #909399;
}
</style>